/** Collapses whitespace in inline block text. Returns a space if empty (prevents DOM collapse). */
export const normalizeInlineBlockValue = (value: string): string => {
  const collapsed = value.replace(/\s+/g, ' ').trim();
  return collapsed || ' ';
};
